import React, { useState, useContext } from 'react';
import { CloseCircleOutlined } from '@ant-design/icons';
import { Input, Col, Button, Modal, Typography, Row, message } from 'antd';
import { useMutation } from '@apollo/react-hooks';
import UPDATE_PAYMENT_VOUCHER_MUTATION from 'shared/graphql/mutation/updatePaymentVoucher';
import formatCurrency from 'shared/utils/formatCurrency';
import { PaymentVoucherContext } from 'views/AccountPayment/common/context/PaymentVoucherContext';
import { formatDateTime } from 'shared/utils/dateTime';

const { Text } = Typography;

const ModalConfirmReject = (props) => {
  const { onCancel, visible } = props;
  const [rejectRemark, setRejectRemark] = useState('');
  const { selectedPaymentVoucherDetail: selectedPaymentVoucherDetailContext } = useContext(
    PaymentVoucherContext,
  );
  const [
    selectedPaymentVoucherDetail,
    setSelectedPaymentVoucherDetail,
  ] = selectedPaymentVoucherDetailContext;
  const {
    paymentVoucherId,
    createDate,
    voucherNumber,
    grandTotalPrice,
  } = selectedPaymentVoucherDetail;

  const closeModalHandler = () => {
    setSelectedPaymentVoucherDetail((prevState) => ({
      ...prevState,
      isOpenModal: false,
    }));
  };

  const [updatePaymentVoucher, { loading }] = useMutation(UPDATE_PAYMENT_VOUCHER_MUTATION, {
    update: (_cache, { data }) => {
      const { _id } = data.updatePaymentVoucher;
      if (_id) {
        message.success('เปลี่ยนสถานะเป็นปฏิเสธแล้ว');
        onCancel();
        closeModalHandler();
      }
    },
    onError: (error) => {
      message.error(error.message);
    },
    refetchQueries: () => ['PaymentVoucher', 'PaymentVouchers', 'PaymentVoucherStatus'],
  });

  const confirmReject = () => {
    updatePaymentVoucher({
      variables: {
        _id: paymentVoucherId,
        voucher_status: 5,
        reject_remark: rejectRemark,
      },
    });
  };

  return (
    <Modal
      title="ปฏิเสธใบสำคัญจ่ายนี้หรือไม่?"
      visible={visible}
      onCancel={onCancel}
      footer={[
        <Button
          key="okButton"
          icon={<CloseCircleOutlined />}
          type="red--light"
          onClick={() => confirmReject()}
          loading={loading}
          disabled={rejectRemark === ''}
        >
          ปฏิเสธ
        </Button>,
        <Button
          key="cancelButton"
          icon={<CloseCircleOutlined />}
          onClick={onCancel}
          disabled={loading}
        >
          ยกเลิก
        </Button>,
      ]}
    >
      <Row>
        <Col span={6}>วันที่เอกสาร:</Col>
        <Col span={18}>
          <Text strong>{formatDateTime(createDate)}</Text>
        </Col>
      </Row>
      <Row>
        <Col span={6}>รหัสใบสำคัญจ่าย:</Col>
        <Col span={18}>
          <Text strong>{voucherNumber}</Text>
        </Col>
      </Row>
      <Row>
        <Col span={6}>มูลค่าใบสำคัญจ่าย:</Col>
        <Col span={18}>
          <Text strong>{formatCurrency(grandTotalPrice, '0')}</Text>
        </Col>
      </Row>
      <Row>
        <Col span={6}>
          เหตุผล:<Text type="danger">*</Text>
        </Col>
        <Col span={18}>
          <Input
            allowClear
            value={rejectRemark}
            placeholder="ระบุเหตุผล"
            name="remark"
            onChange={(event) => setRejectRemark(event.target.value)}
          />
        </Col>
      </Row>
    </Modal>
  );
};

export default ModalConfirmReject;
